/* eslint-disable dot-notation */
'use strict'

import Vue from 'vue'
import axios from 'axios'
import qs from 'qs'

// Full config:  https://github.com/axios/axios#request-config
axios.defaults.baseURL = '/rest2'

const config = {
  // baseURL: process.env.baseURL || process.env.apiUrl || ""
  timeout: 60 * 1000, // Timeout
  withCredentials: true // Check cross-site Access-Control
}

const _axios = axios.create(config)

_axios.interceptors.request.use(
  function (config) {
    config.data = qs.stringify(config.data)
    const token = window.localStorage.getItem('KEY_TOKEN', '')
    const jToken = window.localStorage.getItem('KEY_J_TOKEN', '')
    // const token = 'ED70D4AC477546B9B429342804D57B5D'
    // const jToken = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJtb2JpbGUiOiJFRDcwRDRBQzQ3NzU0NkI5QjQyOTM0MjgwNEQ1N0I1RCIsImV4cCI6MTU5ODc1NjI5M30.L90QSU44Oynw5jG0_pR5rrF9QygDslK0UIql7KP3UfI'
    if (token) {
      config.headers['token'] = token
    }
    if (jToken) {
      config.headers['jtoken'] = jToken
    }
    // Do something before request is sent

    config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8'
    return config
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error)
  }
)

// Add a response interceptor
_axios.interceptors.response.use(
  function (response) {
    // Do something with response data
    return response
  },
  function (error) {
    // Do something with response error
    return Promise.reject(error)
  }
)

Plugin.install = function (Vue, options) {
  Vue.axios = _axios
  window.axios = _axios
  Object.defineProperties(Vue.prototype, {
    axios: {
      get () {
        return _axios
      }
    },
    $axios: {
      get () {
        return _axios
      }
    }
  })
}

Vue.use(Plugin)

export default Plugin
